const inBrowser = (typeof window !== 'undefined');

export default inBrowser;
